import ArchivableModel from 'src/models/archivable/ArchivableModel'
import { IsoDateTime } from 'src/models/model'
import Concern from 'src/models/model/concerns/Concern'

/**
 * Archivable provides archiving functionality to a Model.
 */
export default class Archivable extends Concern {
  static archivable = true

  get archivable () {
    return true
  }

  static fields = {
    archivedAt: {
      type: IsoDateTime,
      output: true
    }
  }

  static computed = {
    isActive () {
      return this.isUnarchived
    },
    isArchived () {
      return !_.isNil(this.archivedAt)
    },
    isUnarchived () {
      return _.isNil(this.archivedAt)
    }
  }

  archive (nullify = false) {
    return ArchivableModel.archiveModel(this.typeName, this.id, nullify)
  }

  unarchive () {
    return ArchivableModel.unarchiveModel(this.typeName, this.id)
  }
}
